import React, { useState } from "react";
import "./cssBoiler.css";
import "./ProjectsSection.css";
import Pro1 from "./assets/pro1.png";
import Pro2 from "./assets/pro2.png";
import Pro3 from "./assets/pro3.png";
import Pro4 from "./assets/pro4.png";
import Pro5 from "./assets/Pro5.png";
import {
  SiReact,
  SiNextdotjs,
  SiNodedotjs,
  SiMongodb,
  SiExpress,
  SiMysql,
  SiDocker,
  SiSocketdotio,
  SiGoogle,
  SiTailwindcss,
  SiPrisma,
  SiNginx,
  SiCloudflare,
  SiVlcmediaplayer,
  SiNpm,
} from "react-icons/si";

function ProjectsSection() {
  const [hoveredProject, setHoveredProject] = useState(null);

  const projects = [
    {
      id: 1,
      title: "JagStream",
      subtitle: "Video Streaming Platform",
      tech: "Node.js + HLS + Docker",
      description:
        "A full-featured video platform with HLS streaming, live upload progress via SSE, and smart recommendations. Built using React, Tailwind, Node.js, Prisma, PostgreSQL, FFmpeg, Nginx, and Azure.",
      image: Pro1,
      github: "https://github.com/yuvrajSoneja2004/That-Video-Streaming-App",
      live: "https://jagstream.yuvrajsoneja.in/",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      techStack: [
        { name: "React", icon: SiReact },
        { name: "Tailwind", icon: SiTailwindcss },
        { name: "Node.js", icon: SiNodedotjs },
        { name: "Prisma", icon: SiPrisma },
        { name: "PostgreSQL", icon: SiMysql },
        { name: "FFmpeg", icon: SiVlcmediaplayer },
        { name: "Nginx", icon: SiNginx },
        { name: "Azure", icon: SiCloudflare },
      ],
    },
    {
      id: 2,
      title: "BrewTrack",
      subtitle: "Coffee Inventory CMS",
      tech: "MERN + Google Sheets API",
      description:
        "A role-based inventory management CMS powered by Google Sheets API. Enables real-time sync, secure access with JWT, and cost tracking with seamless UI.",
      image: Pro1,
      github: "https://github.com/yuvrajSoneja2004/coffee",
      live: "https://coffee-test-nu.vercel.app/",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      techStack: [
        { name: "Next.js", icon: SiNextdotjs },
        { name: "Node.js", icon: SiNodedotjs },
        { name: "MongoDB", icon: SiMongodb },
        { name: "Express", icon: SiExpress },
        { name: "Google Sheets API", icon: SiGoogle },
      ],
    },
    {
      id: 3,
      title: "Ask Wisdom",
      subtitle: "Social Community App",
      tech: "React + Socket.io",
      description:
        "A community-driven platform with Communities (like Reddit), media uploads, and post interactions. Built with Node.js, Socket.io, Multer, and a responsive Next.js UI.",
      image: Pro1,
      github: "https://github.com/yuvrajSoneja2004/ask-wishdom",
      live: "https://ask-wishdom-client.netlify.app/",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      techStack: [
        { name: "Next.js", icon: SiNextdotjs },
        { name: "Node.js", icon: SiNodedotjs },
        { name: "Socket.io", icon: SiSocketdotio },
        { name: "Multer", icon: SiNpm },
        { name: "MongoDB", icon: SiMongodb },
      ],
    },
  ];

  return (
    <div className="projects-section" id="projects">
      <div className="projects-container">
        <div className="projects-header">
          <div className="section-badge">
            <span>Featured Work</span>
          </div>
          <h2 className="projects-title">
            Selected <span className="gradient-text">Projects</span>
          </h2>
          <p className="projects-subtitle">
            A showcase of my most impactful work, demonstrating expertise across
            the full development stack
          </p>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div
              key={project.id}
              className={`project-card ${
                hoveredProject === project.id ? "hovered" : ""
              }`}
              onMouseEnter={() => setHoveredProject(project.id)}
              onMouseLeave={() => setHoveredProject(null)}
              style={{ "--delay": `${index * 0.1}s` }}
            >
              <div className="project-card-inner">
                <div className="project-image-container">
                  <div
                    className="project-image"
                    style={{
                      backgroundImage: `url(${project.image})`,
                      background: project.gradient,
                    }}
                  >
                    <div className="project-overlay">
                      <div className="project-links">
                        <a
                          href={project.github}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="project-link github-link"
                        >
                          <i className="fab fa-github"></i>
                        </a>
                        {project.live && (
                          <a
                            href={project.live}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-link live-link"
                          >
                            <i className="fas fa-external-link-alt"></i>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="project-content">
                  <div className="project-tech">{project.tech}</div>
                  <h3 className="project-title">{project.title}</h3>
                  <h4 className="project-subtitle">{project.subtitle}</h4>
                  <p className="project-description">{project.description}</p>

                  <div className="project-footer">
                    <div className="tech-stack">
                      {project.techStack.map((tech, index) => (
                        <div
                          key={index}
                          className="tech-item"
                          title={tech.name}
                        >
                          {typeof tech.icon === "string" ? (
                            <span className="tech-icon">{tech.icon}</span>
                          ) : (
                            <tech.icon className="tech-icon-svg" />
                          )}
                          <span className="tech-name">{tech.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectsSection;
